/**
 * Sales Hub.
 *
 * Combines sales orders, the deal pipeline (CRM), quotes, customer
 * management, and live auction mode into a single tabbed page.
 * Everything related to selling.
 */

import {
  ShoppingCart,
  Target,
  UserCircle,
  Gavel,
  FileText,
} from "lucide-react";
import HubTabs from "@/components/ui/HubTabs";
import { useTabState } from "@/hooks/useTabState";
import SalesPage from "@/pages/SalesPage";
import DealsPage from "@/pages/DealsPage";
import QuotesListPage from "@/pages/QuotesListPage";
import CustomersPage from "@/pages/CustomersPage";
import AuctionPage from "@/pages/AuctionPage";

const tabs = [
  { key: "orders", label: "Orders", icon: ShoppingCart },
  { key: "pipeline", label: "Pipeline", icon: Target },
  { key: "quotes", label: "Quotes", icon: FileText },
  { key: "customers", label: "Customers", icon: UserCircle },
  { key: "auctions", label: "Auctions", icon: Gavel },
];

function SalesHub() {
  const [activeTab, setActiveTab] = useTabState("tab", "orders");

  return (
    <div className="page-wide space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-[var(--text-primary)]">Sales</h2>
        <p className="mt-1 text-sm text-[var(--text-secondary)]">
          Sales orders, deal pipeline, quotes, customer management, and auction
          events.
        </p>
      </div>

      <HubTabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />

      {activeTab === "orders" && <SalesPage />}
      {activeTab === "pipeline" && <DealsPage />}
      {activeTab === "quotes" && <QuotesListPage />}
      {activeTab === "customers" && <CustomersPage />}
      {activeTab === "auctions" && <AuctionPage />}
    </div>
  );
}

export default SalesHub;
